/* This file was automatically generated - please modify the template not this file! */

import componentRoutes from "./components/componentRoutes";
import Base from "./components/Base";
import { CustomerCategory, CustomerCategoryState, CustomerCategoryListModel } from "./model";
import { customerCategories as reducer } from "./reducer";
import { routes } from "./routes";
import { loadCustomerCategories, loadCustomerCategoriesSuccess } from "./actions";
import * as selectors from "./selectors";
import { customerCategoryApi } from "./customerCategoryApi";

export {
    CustomerCategory,
    CustomerCategoryListModel,
    componentRoutes,
    reducer,
    CustomerCategoryState,
    routes,
    loadCustomerCategories,
    loadCustomerCategoriesSuccess,
    selectors,
    Base,
    customerCategoryApi
};
